import React, { forwardRef } from "react";

interface LockSubmitModalProps {
  onConfirm: () => void;
  onCancel?: () => void;
  loading?: boolean;
}

export interface LockSubmitModalRef {
  showModal: () => void;
  close: () => void;
}

export const LockSubmitModal = forwardRef<
  LockSubmitModalRef,
  LockSubmitModalProps
>(({ onConfirm, onCancel, loading = false }, ref) => {
  const dialogRef = React.useRef<HTMLDialogElement>(null);

  React.useImperativeHandle(ref, () => ({
    showModal: () => dialogRef.current?.showModal(),
    close: () => dialogRef.current?.close(),
  }));

  return (
    <dialog ref={dialogRef} className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Confirm submission</h3>
        <p className="py-4 text-base">
          Once submitted, the assessment will be locked.
        </p>
        <form method="dialog">
          <div className="modal-action">
            <button
              className="btn btn-outline"
              type="button"
              disabled={loading}
              onClick={() => {
                if (onCancel) onCancel();
                dialogRef.current?.close();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                onConfirm();
                dialogRef.current?.close();
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading loading-spinner loading-sm"></span>
                  Submitting...
                </>
              ) : (
                "Confirm submission"
              )}
            </button>
          </div>
        </form>
      </div>
    </dialog>
  );
});

LockSubmitModal.displayName = "LockSubmitModal";
